import React from "react";

const TESTIMONIALS = [
  {
    quote: "They walked us through every page. Cheaper than the attorney we almost hired, and ten times warmer.",
    author: "Marcus & Lina T.",
    role: "Buyers · Hyattsville, MD",
  },
  {
    quote: "I've sent forty closings their way. Not one has gone sideways.",
    author: "D. Halloran",
    role: "Realtor · Bethesda",
  },
  {
    quote: "Our lender called them \"the cleanest title file we've seen this year.\"",
    author: "J. Owusu",
    role: "Buyer · Washington, D.C.",
  },
];

export default function Testimonials() {
  return (
    <>
      {/* ── Desktop: 3-column grid ── */}
      <section style={{ padding: "0 64px 120px" }} className="pte-testimonials-desktop">
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 24 }}>
          {TESTIMONIALS.map((t, i) => (
            <div key={i} style={{
              background: "var(--paper)",
              border: "1px solid var(--line)",
              padding: "36px 32px",
              borderRadius: 8,
            }}>
              <div style={{
                fontFamily: "var(--serif)",
                fontSize: 56,
                lineHeight: 0.5,
                color: "var(--gold)",
                marginBottom: 20,
              }}>
                &ldquo;
              </div>
              <p style={{
                fontFamily: "var(--serif)",
                fontSize: 21,
                lineHeight: 1.35,
                color: "var(--maroon)",
                marginBottom: 32,
                minHeight: 120,
              }}>
                {t.quote}
              </p>
              <div style={{ borderTop: "1px solid var(--line)", paddingTop: 16 }}>
                <div style={{ fontSize: 14, fontWeight: 600, color: "var(--ink)" }}>{t.author}</div>
                <div style={{ fontSize: 13, color: "var(--ink-soft)" }}>{t.role}</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── Mobile: single card ── */}
      <section style={{ padding: "0 20px 64px" }} className="pte-testimonials-mobile">
        <div className="eyebrow" style={{ marginBottom: 12 }}>Clients</div>
        <h2 style={{ fontSize: 36, marginBottom: 24, lineHeight: 1.02 }}>
          What people say<br />after closing day.
        </h2>
        <div style={{
          background: "var(--paper)",
          border: "1px solid var(--line)",
          borderRadius: 8,
          padding: 24,
        }}>
          <div style={{ fontFamily: "var(--serif)", fontSize: 48, lineHeight: 0.5, color: "var(--gold)", marginBottom: 16 }}>
            &ldquo;
          </div>
          <p style={{ fontFamily: "var(--serif)", fontSize: 21, lineHeight: 1.3, color: "var(--maroon)", marginBottom: 24 }}>
            {TESTIMONIALS[0].quote}
          </p>
          <div style={{ borderTop: "1px solid var(--line)", paddingTop: 14 }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: "var(--ink)" }}>{TESTIMONIALS[0].author}</div>
            <div style={{ fontSize: 12, color: "var(--ink-soft)" }}>{TESTIMONIALS[0].role}</div>
          </div>
        </div>
        <div style={{ display: "flex", gap: 6, marginTop: 16, justifyContent: "center" }}>
          {[0, 1, 2].map((i) => (
            <div key={i} style={{
              width: i === 0 ? 24 : 6,
              height: 6,
              borderRadius: 999,
              background: i === 0 ? "var(--maroon)" : "var(--line)",
            }} />
          ))}
        </div>
      </section>

      <style>{`
        .pte-testimonials-desktop { display: block; }
        .pte-testimonials-mobile  { display: none; }
        @media (max-width: 768px) {
          .pte-testimonials-desktop { display: none; }
          .pte-testimonials-mobile  { display: block; }
        }
      `}</style>
    </>
  );
}
